export default () => ({
    //payment
    cc              : '',
    expiration_month: '',
    expiration_year : '',
    cvv             : '',
    agreement       : false,
    _nounce         : '',
    stripeToken         : '',
    kiosk_cash_pay  : false,
    g_recaptcha_response : '',
});
